import React from 'react';
import { Provider } from 'react-redux';
import Main from './components/Main';
import { I18nextProvider } from 'react-i18next';
import { ExperimentsProvider } from '@wix/wix-experiments-react';

export default function ({ store, i18n }) {
  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <ExperimentsProvider options={{ scope: 'restaurants' }}>
          <Main />
        </ExperimentsProvider>
      </I18nextProvider>
    </Provider>
  );
}
